<template>
    <transition v-if="ui.listening.texToListen" name="fade-translate">
        <div v-if="ui.listening.opened">
            <div v-if="onlyMobileVisible" class="fixed inset-0 z-[600] bg-black/40" @click="closeListeningPlayer" />

            <div
                ref="ttsCard"
                :class="[
                    'fixed bg-theme-bg p-3 text-theme-text shadow-[0_4px_20px_rgba(0,0,0,0.15)]',
                    onlyMobileVisible
                        ? 'bottom-0 left-0 right-0 z-[601] w-full rounded-t-xl pb-[calc(12px+env(safe-area-inset-bottom,0px))] shadow-[0_-4px_20px_rgba(0,0,0,0.15)] transition-transform duration-200 ease-out'
                        : 'left-auto right-1.5 z-600 w-72 rounded-xl',
                    { 'z-[999]': isHighlightsMobile },
                    { '!transition-none': isDragging },
                ]"
                :style="mobileCardStyle || (!onlyMobileVisible ? positionFloat : null)"
                @touchstart="onTouchStart"
                @touchmove="onTouchMove"
                @touchend="onTouchEnd"
            >
                <div
                    v-if="onlyMobileVisible"
                    class="flex cursor-pointer items-center justify-center pb-3 pt-2 [-webkit-tap-highlight-color:transparent]"
                    @click="closeListeningPlayer"
                >
                    <div class="h-1 w-9 rounded-sm bg-current opacity-20" />
                </div>

                <component :is="currentIntegration" :text="ui.listening.texToListen" class="w-full" />
            </div>
        </div>
    </transition>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
    data() {
        return {
            currentIntegration: null,
            text: '',
            touchStartY: 0,
            translateY: 0,
            isDragging: false,
        };
    },
    computed: {
        ...mapState(['uiHidden', 'integrations', 'localizations', 'lang', 'ui', 'device', 'embeddedInMobileApp']),
        ...mapGetters(['onlyMobileVisible']),
        positionFloat() {
            let top = 60;
            if (this.uiHidden) {
                top = 10;
            }
            return `top:${top}px`;
        },
        mobileCardStyle() {
            if (!this.onlyMobileVisible || !this.translateY) return null;
            return `transform: translateY(${this.translateY}px)`;
        },
        isHighlightsMobile() {
            return this.ui.features.highlights.opened && this.onlyMobileVisible;
        },
        speechDriver() {
            /*
             * We always use 'amazon-polly' when embedded in a mobile app because the
             * 'native-tts' driver uses the browser's native TTS api - SpeechSynthesisUtterance() -
             * and in the app we do not have reliable support of the browser's native TTS api.
             *
             * Map backend driver values to integration keys for backward compatibility.
             * Backend sends 'amazon-polly' but frontend uses 'listen' integration key.
             */
            let driver = 'native-tts';
            if (this.embeddedInMobileApp || this.ui.listening.driver === 'amazon-polly') {
                driver = 'amazon-polly';
            }

            // Map old backend driver values to new integration keys
            const driverToIntegrationKey = {
                'amazon-polly': 'listen', // Backend sends 'amazon-polly', we use 'listen' integration
                'native-tts': 'native-tts', // Unchanged
            };

            return driverToIntegrationKey[driver] || driver;
        },
    },
    mounted() {
        console.log('debug:components tts');
        this.handleIntegration(this.integrations.items[this.speechDriver].component, this.ui.listening.texToListen);
    },
    methods: {
        ...mapMutations(['closeListeningPlayer']),
        handleIntegration(integrationSlug, text) {
            this.currentIntegration = integrationSlug;
            this.text = text;
        },
        onTouchStart(e) {
            if (!this.onlyMobileVisible) return;
            this.touchStartY = e.touches[0].clientY;
            this.isDragging = true;
        },
        onTouchMove(e) {
            if (!this.isDragging) return;
            const deltaY = e.touches[0].clientY - this.touchStartY;
            this.translateY = Math.max(0, deltaY);
        },
        onTouchEnd() {
            if (!this.isDragging) return;
            this.isDragging = false;
            if (this.translateY > 80) {
                this.closeListeningPlayer();
            }
            this.translateY = 0;
        },
    },
};
</script>
